<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="验收单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else>验收单号:{{ form.no }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item label="创建时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间"
                  style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="发起人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>发起人:{{ form.createdUserName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="ownerDeptName" label="所属科室" v-if="getIsView()">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>所属科室:{{ form.ownerDeptName }} </span>
            </el-col>
          </el-row>

          <el-row>
            <!-- v-if="system_setting.IsFirWarehouseStockMode" -->
            <el-col v-if="system_setting.IsFirWarehouseStockMode" :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="stockUpPleaseNo" label="备货请领单" v-if="getIsView()">
                <el-select v-model="form.stockUpPleaseNo" :disabled="!editMode" placeholder="请选择" filterable
                  :filter-method="(value) => getStockUpPleases(value, 1)" @change="stockUpPleasesChange"
                  style="width: 100%">
                  <el-option v-for="item in STATIC_GetStockUpPleases" :key="item.id"
                    :label="item.no + ' ' + item.applyDeptName" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>备货请领单:{{ form.stockUpPleaseNo }} </span>
            </el-col>

            <el-col v-if="!system_setting.IsFirWarehouseStockMode" :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="supplierName" label="供应商" v-if="getIsView()">
                <el-select v-model="form.supplierName" :disabled="!editMode" placeholder="请选择" filterable
                  :filter-method="(value) => getSuppliers(value, 1)" @change="supplierChange" style="width: 100%">
                  <el-option v-for="item in STATIC_Suppliers" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>供应商:{{ form.supplierName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="deliveryTime" label="预计送达日期" v-if="getIsView()">
                <el-date-picker :disabled="!editMode" v-model="form.deliveryTime" size="small" type="date"
                  format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="送货日期" style="width: 100%"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>预计送达日期:{{ parseTime(new Date(form.deliveryTime), "{y}-{m}-{d}") }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="warehouseName" v-if="getIsView()" :label="system_setting.IsFirWarehouseStockMode ? '调入库房' : '存放库房'">
                <el-select v-if="system_setting.IsUseWard" v-model="form.warehouseName" placeholder="请选择"
                  :disabled="!editMode && !approveDisable" style="width: 100%" filterable
                  :filter-method="system_setting.IsFirWarehouseStockMode ? getWarehousesDeptWards : getWarehousesDeptWardsLevelTwo"
                  @change="applyDeptChange1">
                  <el-option v-for="item in STATIC_Depts" :key="item.idGroup"
                    :label="item.warehouseName + ' ' + item.deptName + ' ' + (item.wardName ? item.wardName : '')"
                    :value="item.idGroup"></el-option>
                </el-select>
                <el-select v-else v-model="form.warehouseName" :disabled="!editMode && !approveDisable"
                  placeholder="请选择存放库房" filterable :filter-method="getWarehouseList" @change="warehouseChange"
                  style="width: 100%">
                  <el-option v-for="item in warehouseList" :key="item.id + ';' + item.deptIds"
                    :label="item.name + ' ' + item.deptNames + ' '" :value="item.id + ';' + item.deptIds"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>存放库房:{{ form.warehouseName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="stockUpPlanNo" label="备货计划" v-if="getIsView()">
                <el-input disabled v-model="form.stockUpPlanNo"></el-input>
              </el-form-item>
              <span class="viewText" v-else>备货计划:{{ form.stockUpPlanNo }} </span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="oneLevelWarehouseId" v-if="getIsView()" :label="system_setting.IsFirWarehouseStockMode ? '调出库房' : '收货库房'">
                <el-select v-model="form.oneLevelWarehouseName" :disabled="!editMode" placeholder="请选择收货库房"
                  style="width: 100%" filterable v-if="system_setting.IsFirWarehouseStockMode"
                  :filter-method="getWarehousesBySessionWarehouseId" @change="oneLevelWarehouseChange">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>

                <el-select v-else v-model="form.oneLevelWarehouseName" :disabled="!editMode" placeholder="请选择收货库房"
                  style="width: 100%" filterable :filter-method="getOneLevelWarehousesBySessionWarehouseId"
                  @change="oneLevelWarehouseChange1">
                  <el-option v-for="item in STATIC_OneLevelWarehouses" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>


              </el-form-item>
              <span class="viewText" v-else>收货库房:{{ form.oneLevelWarehouseName }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="warehouseManagerId" v-if="getIsView()" label="库管员">
                <el-input disabled v-model="form.warehouseManagerName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>库管员:{{ form.warehouseManagerName }} </span>
            </el-col>

            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="logistics" label="物流单号" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="请输入物流单号" v-model="form.logistics" type="text"></el-input>
              </el-form-item>
              <span class="viewText" v-else>物流单号:{{ form.logistics }} </span>
            </el-col>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalNumber" label="总数量" v-if="getIsView()">
                <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber"></el-input>
              </el-form-item>
              <span class="viewText" v-else>总数量:{{ form.totalNumber }} </span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="totalAmount" label="配送总金额" v-if="getIsView()">
                <el-input disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
              </el-form-item>
              <span class="viewText" v-else>配送总金额:{{ form.totalAmount }} </span>
            </el-col>
            <el-col :span="12" :class="!getIsView()?'viewCol':''">
              <el-form-item label="备注" prop="remark" v-if="getIsView()">
                <el-input :disabled="!approveDisable" placeholder="备注" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else>备注:{{ form.remark }} </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" >
              <el-form-item label="" prop="fileInfos">
                <UploadFileList label="上传附件" :fileList="form.fileInfos ? form.fileInfos : []" btnShowType="always"
                  :multipleFile="false" :showFileList="true" :editMode="editMode" @fileChange="filesChange">
                </UploadFileList>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">验收明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" :disabled="childMultiple" v-preventReClick type="danger"
              @click="handleDeleteChildForm">删除</el-button>
            <el-button class="btn default" size="small" v-preventReClick @click="openScanner">点击开始扫描</el-button>
            <el-button class="btn primary" type="primary" style="margin-left:20px"
              @click="showTransfer">自定义设置</el-button>
            <!-- <el-input :disabled="!editMode" v-if="system_setting.IsFirWarehouseStockMode" placeholder="扫描标签码添加明细" v-model="tagCode" ref="tagCodeInput" style="width:300px;margin-left:30px" @change="tagCodeChange"></el-input> -->
          </div>
          <div v-else style="margin: 20px 0 12px 10px">
            <el-button class="btn primary" type="primary" style="margin-left:20px"
              @click="showTransfer">自定义设置</el-button>
            <el-button class="btn default" v-if="!showWorkFlowInfo" size="small" v-preventReClick @click="packCodeEvt">动态打包</el-button>
            <!-- <el-button class="btn primary" size="small" type="primary" v-preventReClick @click="acceptEvt">一键验收</el-button> -->
          </div>


          <ScanCodeAcceptance v-if="form.details && form.status == 1" :data="form.details"
            @verificationEvt="verificationEvt" />


          <div v-if="tableHaeder.length > 0">
            <CustomTable ref="customTable" :tableData="form.details" @handleSelectionChange="handleChildSelectionChange"
              :tableHaeder="tableHaeder" :loading="loading" :tableHeight="tableHeight" :tableCode="route.name"
              :cellDblclick="cellDblclick">
              <template slot="before">
                <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
                </el-table-column>
              </template>
              <template slot="after">
                <el-table-column fixed="right" v-if="$route.query.formMode == 3 || $route.query.formMode == 0" label="重新配送"
                  width="100">
                  <template slot-scope="scope">
                    <!-- @change="(res)=>reDeliveryChange(res,scope.row)" -->
                    <el-switch v-model="scope.row.reDelivery" :disabled="$route.query.formMode == 0"
                      active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0">
                    </el-switch>
                  </template>
                </el-table-column>
                <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" v-if="scope.row.hasTagCode == 1" v-preventReClick class="color-blue"
                      @click="tagCodeView(scope.row)">查看</el-button>
                  </template>
                </el-table-column>
              </template>
            </CustomTable>
          </div>
          <div v-else>
            <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" max-height="600"
              @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe
              :header-cell-style="{ background: '#DDEBFF' }" :row-class-name="tableRowClassName">
              <el-table-column type="index" width="50" fixed> </el-table-column>
              <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
              <el-table-column show-overflow-tooltip prop="productName" fixed label="产品" width="180"></el-table-column>
              <el-table-column show-overflow-tooltip prop="specName" fixed label="产品规格" width="120"></el-table-column>
              <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
              <el-table-column show-overflow-tooltip prop="productRegistCertName" label="产品注册证"
                width="180"></el-table-column>

              <!-- <el-table-column prop="brand" label="品牌" width="100"></el-table-column> -->
              <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" width="120"></el-table-column>
              <el-table-column prop="number" label="数量" width="100"></el-table-column>
              <!-- <el-table-column prop="unUseNumber" label="未使用数量" width="100"></el-table-column> -->
              <el-table-column prop="refundNumber" label="退货数量" width="100"></el-table-column>
              <el-table-column prop="minUnit" label="最小单位" width="100"></el-table-column>
              <el-table-column prop="unit" label="包装单位" width="100"></el-table-column>
              <el-table-column prop="price" label="单价" width="100"></el-table-column>
              <el-table-column prop="amount" label="小计" width="100"></el-table-column>
              <el-table-column prop="packSpec" label="包装规格" width="120"></el-table-column>
              <el-table-column prop="locationName" label="货位" width="120"></el-table-column>
              <el-table-column prop="batch" label="批次号" width="100"></el-table-column>
              <el-table-column prop="validityDate" label="有效期" width="150">
                <template slot-scope="scope">
                  {{
                    scope.row.validityDate
                      ? parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}")
                      : ""
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="longTime" label="长期" width="60">
                <template slot-scope="scope">
                  {{ scope.row.longTime == 1 ? "是" : "否" }}
                </template>
              </el-table-column>
              <el-table-column prop="manufactureDate" label="生产日期" width="150">
                <template slot-scope="scope">
                  {{
                    scope.row.manufactureDate
                      ? parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}")
                      : ""
                  }}
                </template>
              </el-table-column>
              <!-- <el-table-column prop="disinfectDate" label="灭菌日期" width="150">
            <template slot-scope="scope">
              {{
                scope.row.disinfectDate
                  ? parseTime(new Date(scope.row.disinfectDate), "{y}-{m}-{d}")
                  : ""
              }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip prop="disinfectBatch" label="灭菌批号" width="120"></el-table-column> -->
              <el-table-column show-overflow-tooltip prop="serialNo" label="序列号" width="120"></el-table-column>
              <el-table-column show-overflow-tooltip prop="mainNo" label="主条码" width="120"></el-table-column>
              <el-table-column show-overflow-tooltip prop="traceNo" label="追溯码" width="120"></el-table-column>
              <el-table-column show-overflow-tooltip prop="productRegistCertNo" label="注册证号"
                width="120"></el-table-column>
              <el-table-column show-overflow-tooltip prop="onlineNo" label="挂网号" width="100"></el-table-column>
              <el-table-column show-overflow-tooltip prop="remark" label="备注" width="200"></el-table-column>
              <el-table-column show-overflow-tooltip prop="newProductId" label="产品ID" width="150" />
              <el-table-column show-overflow-tooltip prop="productCode" label="商品代码" width="150" />
              <el-table-column show-overflow-tooltip prop="newOnlineNo" label="新挂网号" width="150" />
              <el-table-column show-overflow-tooltip prop="medicalInsuranceCategoryNo" label="医保代码" width="150" />
              <el-table-column fixed="right" prop="reDelivery" v-if="$route.query.formMode == 3 || $route.query.formMode == 0"
                label="重新配送" width="100">
                <template slot-scope="scope">
                  <!-- @change="(res)=>reDeliveryChange(res,scope.row)" -->
                  <el-switch v-model="scope.row.reDelivery" :disabled="$route.query.formMode == 0" active-color="#286AB4"
                    inactive-color="#D4D4D4" :active-value="1" :inactive-value="0">
                  </el-switch>
                </template>
              </el-table-column>
              <el-table-column fixed="right" prop="operation" label="标签详情" width="100">
                <template slot-scope="scope">
                  <el-button type="text" v-if="scope.row.hasTagCode == 1" v-preventReClick class="color-blue"
                    @click="tagCodeView(scope.row)">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>

        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

      <el-dialog title="产品信息" :visible.sync="openSubformModal" :center="true" width="1100px"
        :before-close="cancelChildDialog" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="childForm" :model="childForm" :rules="childFormRules">
          <el-row v-if="isScan">
            <el-col :span="24">
              <el-form-item label="扫码框">
                <el-input placeholder="请扫码" ref="no" @change="(val) => {
                  mainNoChange(val, '1');
                }
                " v-model="childForm.no" @focus="scanInputFocus" @blur="scanInputBlur"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="mainNo" label="主条码">
                <el-input disabled placeholder="请输入主条码" v-model="childForm.mainNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="traceNo" label="追溯码">
                <el-input disabled placeholder="请输入追溯码" v-model="childForm.traceNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="supplierProductNo" label="供应商产品编码">
                <el-input disabled v-model="childForm.supplierProductNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productName" label="产品">
                <el-input v-if="isScan" disabled v-model="childForm.productName"></el-input>
                <SelectTable v-if="!isScan" :disabled="!editMode"
                  :columns="system_setting.IsFirWarehouseStockMode ? supplierProductColumns1 : supplierProductColumns"
                  :placeholder="'请选择产品'" :innerName="childForm.productName" :dataList="STATIC_SupplierProducts"
                  @filterMethod="getProductList" @change="productChange" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="specName" label="产品规格">
                <el-input disabled v-model="childForm.specName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productRegistCertId" label="产品注册证">
                <el-select :disabled="!editMode" placeholder="请选择注册证" v-model="childForm.productRegistCertName"
                  filterable @change="certChange" style="width: 100%">
                  <el-option v-for="item in STATIC_ProductRegistCertDetails" :key="item.productRegistCertId"
                    :label="item.name + ' ' + item.no" :value="item.productRegistCertId"></el-option>
                </el-select>
                <!-- <el-input disabled v-model="childForm.productRegistCertName"></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productRegistCertNo" label="注册证号">
                <el-input disabled v-model="childForm.productRegistCertNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="manufacturerName" label="生产厂家">
                <el-input disabled v-model="childForm.manufacturerName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="packSpec" label="包装规格">
                <el-input :disabled="!editMode" placeholder="请输入包装规格" v-model="childForm.packSpec"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="brand" label="品牌">
                <el-input disabled v-model="childForm.brand"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="onlineNo" label="挂网号">
                <el-input disabled v-model="childForm.onlineNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="minUnit" label="最小单位">
                <el-input disabled v-model="childForm.minUnit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="unit" label="包装单位">
                <el-input disabled v-model="childForm.unit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="disinfectDate" label="灭菌日期">
                <el-date-picker :disabled="!editMode" v-model="childForm.disinfectDate" size="small" type="date"
                  format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="disinfectBatch" label="灭菌批号">
                <el-input :disabled="!editMode" placeholder="请输入灭菌批号" v-model="childForm.disinfectBatch"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="manufactureDate" label="生产日期">
                <el-date-picker :disabled="!editMode" v-model="childForm.manufactureDate" size="small" type="date"
                  format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="validityDate" label="有效期">
                <el-date-picker :disabled="!editMode || Boolean(childForm.longTime)" v-model="childForm.validityDate"
                  size="small" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择日期"
                  style="width: 100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item prop="longTime" label="长期">
                <el-switch v-model="childForm.longTime" :disabled="!editMode" @change="longTimeChange(childForm)"
                  active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1" :inactive-value="0"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="serialNo" label="序列号">
                <el-input :disabled="!editMode" placeholder="请输入序列号" v-model="childForm.serialNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="batch" label="批次号">
                <el-input :disabled="!editMode" placeholder="请输入批次号" v-model="childForm.batch"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item prop="locationName" label="货位">
                <el-select :disabled="!editMode" placeholder="请选择货位" v-model="childForm.locationName" filterable
                  @change="childLocationChange" style="width: 100%">
                  <el-option v-for="item in STATIC_Locations" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item prop="number" label="数量">
                <el-input-number :disabled="!editMode" v-model="childForm.number" :min="0" :precision="2" ref="number"
                  :controls="false" placeholder="请填写数量" @change="childNumberChange"
                  style="width: 100%"></el-input-number>
                <!-- <el-input :disabled="!editMode" placeholder="请输入数量" type="number" min="0" ref="number" v-model="childForm.number" @input="autoAmount"></el-input> -->
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item prop="price" label="采购价">
                <el-input :disabled="!editMode" @input="autoAmount" v-model="childForm.price"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="amount" label="小计">
                <el-input disabled v-model="childForm.amount"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="newProductId" label="产品ID">
                <el-input disabled v-model="childForm.newProductId"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="productCode" label="商品代码">
                <el-input disabled v-model="childForm.productCode"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item prop="newOnlineNo" label="新挂网号">
                <el-input disabled v-model="childForm.newOnlineNo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item prop="medicalInsuranceCategoryNo" label="医保代码">
                <el-input disabled v-model="childForm.medicalInsuranceCategoryNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item prop="remark" label="备注">
                <el-input :disabled="!editMode" placeholder="请输入备注" v-model="childForm.remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button v-if="!isScan && editMode" class="btn primary" type="primary" size="small" v-preventReClick
            @click="continueAdd">新增下一条</el-button>
          <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确
            定</el-button>
        </div>
      </el-dialog>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode && form.status != 0" class="btn primary" type="primary" v-preventReClick
        @click="proTemSave">暂 存</my-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确
        定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
    </div>
    <LabelPackDialog v-if="labelPackVisible" :open="labelPackVisible" @close="closeLabelPackDialog"
      :toBePackagedData="toBePackagedData" :packagedData="packagedData" @getTableData="getTableData" />

    <LabelDetailsDialog v-if="labelDetailsVisible" :open="labelDetailsVisible" :data="labelDetailsData"
      @tagCodeDelete="tagCodeDelete" @close="closeLabelDetailsDialog" />

    <PackageLabelDialog v-if="packageLabelVisible" :open="packageLabelVisible" :data="packageLabeData"
      @viewDetails="viewDetails" @tagCodeDelete="tagCodeDelete" @close="closePackageLabelDialog" />
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import InNewScan from "@/mixin/inNewScan-mixin";
import tagCodeMixin from "@/mixin/tagCode-mixin";
import {
  RejectStockUpCheck,
  SaveStockUpCheck,
  GetStockUpCheckById,
  GetSupplierProducts,
  GetDeptWarehouses,
  GetProducts,
  ValidateSupplierProducts,
  GetWarehousesByDeptId,
  GetWarehousesByDeptIdAndWard,
  GetStockUpPleaseById,
  GetStocks,
  GetStockViewModelsByPleaseId,
  GetWarehouseById,
  GetUnPackedTagCodeDetailsInStockUpCheck,
  GetPackedTagCodeDetailsInStockUpCheck
} from "@/api";
// import { InStockOptions, WhetherOptions, AssetSourceOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";
import ScanCodeAcceptance from "@/components/scan-code-acceptance";
import LabelDetailsDialog from "@/components/labelDetails-dialog";
import LabelPackDialog from "@/components/labelPack-dialog";
import PackageLabelDialog from "@/components/packageLabel-dialog";
import UploadFileList from "@/components/upload-file-list";
export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin, InNewScan, tagCodeMixin],
  components: {
    SelectTable,
    ApproveInfo,
    ScanCodeAcceptance,
    LabelDetailsDialog,
    LabelPackDialog,
    UploadFileList,
    PackageLabelDialog
  },
  data() {
    return {
      GetDataAction: GetStockUpCheckById,
      SaveDataAction: SaveStockUpCheck,
      reject: RejectStockUpCheck,
      toBePackagedApi: GetUnPackedTagCodeDetailsInStockUpCheck,
      packagedApi: GetPackedTagCodeDetailsInStockUpCheck,
      form: {},
      // InStockOptions: InStockOptions,
      // WhetherOptions: WhetherOptions,
      // AssetSourceOptions: AssetSourceOptions,
      rules: {
        warehouseName: [
          {
            required: true,
            message: "请选择入库仓库",
            trigger: "blur",
          },
        ],
        supplierName: [
          {
            required: true,
            message: "请选择供应商",
            trigger: "blur",
          },
        ],

        oneLevelWarehouseId: [
          {
            required: true,
            message: "请选择收货库房",
            trigger: "blur",
          },
        ],
      },
      childFormRules: {
        productName: [
          {
            required: true,
            message: "请选择产品",
            trigger: "blur",
          },
        ],
        manufactureDate: [
          // { required: true, message: "请选择生产日期", trigger: "blur" },
          {
            validator: this.validateManufacturerDate,
            trigger: "blur",
          },
          {
            validator: this.validateDateRange,
            trigger: "blur",
          },
        ],
        validityDate: [
          // { required: true, message: "请选择有效期", trigger: "blur" },
          {
            validator: this.validateValidityDate,
            trigger: "blur",
          },
          {
            validator: this.validateDateRange,
            trigger: "blur",
          },
        ],
        // batch: [{ required: true, message: "请输入批次号", trigger: "blur" }],
        // productRegistCertId: [
        //   {
        //     required: true,
        //     message: "请选择产品注册证",
        //     trigger: "blur",
        //   },
        // ],
        packSpec: [
          {
            required: true,
            message: "请输入包装规格",
            trigger: "blur",
          },
        ],
        price: [
          {
            required: true,
            message: "请输入采购价",
            trigger: "blur",
          },
        ],
        number: [
          {
            required: true,
            message: "数量不能为空",
            trigger: "blur",
          },
          {
            type: "number",
            min: 0.01,
            message: "数量必须大于0",
            trigger: "blur",
          },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},

      approveDisable: false,
      isScan: false,
      warehouseList: [],
      // orderList: []
    };
  },

  created() {
    var query = this.$route.query;


    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
      if (query.applyId) {
        this.getStockUpPleases('').then(() => {
          this.stockUpPleasesChange(query.applyId)
        })
      } else {
        this.getStockUpPleases('')
      }
    }

    if (this.system_setting.IsUseWard) {
      if (this.system_setting.IsFirWarehouseStockMode) {
        this.getWarehousesDeptWards()
      } else {
        this.getWarehousesDeptWardsLevelTwo()
      }
    } else {
      this.getWarehouseList("");
    }
    this.getSuppliers("", 1);
    // this.getOrderList('')
    if (this.system_setting.IsFirWarehouseStockMode) {
      this.getWarehousesBySessionWarehouseId("");
    } else {
      this.getOneLevelWarehousesBySessionWarehouseId('')
    }
    this.getTabelList("");

  },
  methods: {
    tableRowClassName({ row, rowIndex }) {

      if (row.verification == true) {
        return 'success-row';
      }
      return '';

    },
    verificationEvt(row) {
      this.form.details = this.form.details.map(res => {
        if (res.$index == row.$index) {
          res.verification = true
        }
        return res
      })
      this.$nextTick(() => {
        this.$forceUpdate();  // 强制刷新表格，确保更新显示
      });
    },
    // 新建
    handleAdd() {
      this.resetForm();
      this.editMode = true;
      this.approveDisable = true;
    },
    // 编辑
    handleUpdate(id) {
      return new Promise((resolve, reject) => {
        this.GetDataAction({
          id,
        }).then((res) => {
          // this.resetForm()
          this.form = res.returnData;
          this.getProductList("", 1);
          resolve(res.returnData)
          this.getLocations(this.form.warehouseId);
          this.getWarehouseList("");
          this.form.details.forEach((e, index) => {
            e.$index = index + 1;
          });

          this.initWorkFlowProperty(this.form);

          if (
            this.form.status == 1 &&
            this.form.approverIds &&
            this.form.approverIds.indexOf(this.userInfo.id + "") != -1
          ) {
            this.approveDisable = true;
          }
        });
      });
    },
    // 保存
    submit() {
      this.$store.dispatch('SetLoading', true)
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          this.$store.dispatch('SetLoading', false)
          return false;
        }
        if (!this.form.details || this.form.details.length == 0) {
          this.$my_message("明细表不能为空", "warning");
          this.$store.dispatch('SetLoading', false)
          return;
        }

        let supplierProductIds = this.form.details.map((e) => e.supplierProductId);
        if (!supplierProductIds || supplierProductIds.length == 0) {
          this.$my_message("存在没有供应商产品的明细表", "warning");
          this.$store.dispatch('SetLoading', false)
          return;
        }

        var valdateResult = this.productDetailRepeatValidate(this.form.details);
        let productIds = this.form.details.map((e) => e.productId);
        if (!valdateResult.flag) {
          this.$my_message(valdateResult.msg, "warning");
          this.$store.dispatch('SetLoading', false)
          return;
        }

        var fn = () => {
          if (this.system_setting.IsComparedWarn == 1) {
            // 是否对码
            GetProducts({
              ids: productIds,
            }).then((res) => {
              if (res.successful) {
                const h = this.$createElement;
                let msg = "";
                let content = [];
                let confirm = false;
                let arr = []
                res.returnData.data.forEach((item) => {
                  if (item.isCompared == 0) {
                    confirm = true;
                    for (let i = 0; i < this.form.details.length; i++) {
                      if (this.form.details[i].productId == item.id) {
                        this.form.details[i].INDEX = i
                        arr.push(this.form.details[i])
                      }
                    }
                  }
                });
                let arr1 = [...new Set(arr.map(item => item.productId))].map(id => arr.find(item => item.productId === id))
                arr1.sort((a, b) => a.INDEX - b.INDEX)
                arr1.forEach((j) => {
                  content.push(
                    h(
                      "p",
                      `第${j.INDEX + 1}行：产品名称[${j.productName
                      }]，未对码\n`
                    )
                  );
                  msg += `第${j.INDEX + 1}行：产品名称[${j.productName
                    }]，未对码\n`;
                })
                if (confirm) {
                  this.$confirm("提示", {
                    confirmButtonText: "继续",
                    cancelButtonText: "取消",
                    message: h("div", content),
                    customClass: "promptBox",
                    type: "warning",
                  })
                    .then(() => {
                      ValidateSupplierProducts({
                        ids: supplierProductIds,
                      })
                        .then((res) => {
                          if (res.returnData && res.returnData.length > 0) {
                            const h = this.$createElement;
                            let msg = "";
                            let content = [];
                            res.returnData.forEach((item) => {
                              for (let i = 0; i < this.form.details.length; i++) {
                                if (this.form.details[i].supplierProductId == item.key) {
                                  content.push(
                                    h(
                                      "p",
                                      `第${i + 1}行：产品名称[${this.form.details[i].productName
                                      }]，规格型号[${this.form.details[i].specName}]${item.errorMessage
                                      }\n`
                                    )
                                  );
                                  msg += `第${i + 1}行：产品名称[${this.form.details[i].productName
                                    }]，规格型号[${this.form.details[i].specName}]${item.errorMessage
                                    },\n`;
                                }
                              }
                            });
                            content.push(h("p", `审核通过才能验收。`));
                            msg += "审核通过才能验收。";

                            // this.$alert(msg)
                            this.$confirm("提示", {
                              title: "提示",
                              type: "warning",
                              customClass: "promptBox",
                              showCancelButton: false,
                              showConfirmButton: true,
                              message: h("div", content),
                            }).catch(() => {
                              this.$store.dispatch('SetLoading', false)
                            })
                            throw new Error(msg);
                          }
                        })
                        .then(() => {
                          return GetSupplierProducts({
                            ids: supplierProductIds,
                            pageIndex: 1,
                            pageSize: 999,
                          })
                        })
                        // GetSupplierProducts({ ids: supplierProductIds, pageIndex: 1, pageSize: 999 })
                        .then((res) => {
                          let msg = "";
                          res.returnData.data.forEach((item) => {
                            if (item.isEnabled == 0 && item.isTempPurchase == 0) {
                              this.form.details.forEach((detail, index) => {
                                if (detail.supplierProductId == item.id) {
                                  msg += `第${index + 1}行：${detail.supplierProductNo
                                    } 产品名称 [${detail.productName}] 规格型号 [${detail.specName
                                    }] <br/>`;
                                }
                              });
                            }
                          });
                          if (msg) {
                            msg += "已被禁用，请核对后再验收";
                            this.$my_message(msg, "warning");
                            this.$store.dispatch('SetLoading', false)
                            throw new Error(msg);
                          }

                          let flag = false;
                          const h = this.$createElement;
                          let content = [];
                          this.form.details.forEach((detail, index) => {
                            res.returnData.data.forEach((item) => {
                              if (
                                // item.billingLogo == 1 &&
                                detail.supplierProductId == item.id &&
                                detail.price != item.purchasePrice
                              ) {
                                content.push(
                                  h(
                                    "p",
                                    `第【${index + 1}】行产品的采购价【${detail.price
                                    }】与供应商产品目录里的采购价【${item.purchasePrice
                                    }】不一致;`
                                  )
                                );
                                flag = true;
                              }
                            });
                          });
                          if (flag) {
                            content.push(
                              h(
                                "p",
                                {
                                  style: "color:red",
                                },
                                `是否继续验收？`
                              )
                            );

                            this.$confirm("提示", {
                              title: "提示",
                              type: "warning",
                              message: h("div", content),
                            }).then(() => {
                              // 上传订单
                              this.save();
                            })
                              .catch(() => {
                                this.$store.dispatch('SetLoading', false)
                              });
                          } else {
                            this.save();
                          }
                        });
                    })
                    .catch(() => {
                      this.$store.dispatch('SetLoading', false)
                      throw new Error(msg);
                    });
                } else {
                  ValidateSupplierProducts({
                    ids: supplierProductIds,
                  })
                    .then((res) => {
                      if (res.returnData && res.returnData.length > 0) {
                        const h = this.$createElement;
                        let msg = "";
                        let content = [];
                        res.returnData.forEach((item) => {
                          for (let i = 0; i < this.form.details.length; i++) {
                            if (this.form.details[i].supplierProductId == item.key) {
                              content.push(
                                h(
                                  "p",
                                  `第${i + 1}行：产品名称[${this.form.details[i].productName
                                  }]，规格型号[${this.form.details[i].specName}]${item.errorMessage
                                  }\n`
                                )
                              );
                              msg += `第${i + 1}行：产品名称[${this.form.details[i].productName
                                }]，规格型号[${this.form.details[i].specName}]${item.errorMessage
                                },\n`;
                            }
                          }
                        });
                        content.push(h("p", `审核通过才能验收。`));
                        msg += "审核通过才能验收。";

                        // this.$alert(msg)
                        this.$confirm("提示", {
                          title: "提示",
                          type: "warning",
                          customClass: "promptBox",
                          showCancelButton: false,
                          showConfirmButton: true,
                          message: h("div", content),
                        });
                        throw new Error(msg);
                      }
                    })
                    .then(() => {
                      return GetSupplierProducts({
                        ids: supplierProductIds,
                        pageIndex: 1,
                        pageSize: 999,
                      });
                    })
                    // GetSupplierProducts({ ids: supplierProductIds, pageIndex: 1, pageSize: 999 })
                    .then((res) => {
                      let msg = "";
                      res.returnData.data.forEach((item) => {
                        if (item.isEnabled == 0 && item.isTempPurchase == 0) {
                          this.form.details.forEach((detail, index) => {
                            if (detail.supplierProductId == item.id) {
                              msg += `第${index + 1}行：${detail.supplierProductNo
                                } 产品名称 [${detail.productName}] 规格型号 [${detail.specName
                                }] <br/>`;
                            }
                          });
                        }
                      });
                      if (msg) {
                        msg += "已被禁用，请核对后再验收";
                        this.$my_message(msg, "warning");
                        this.$store.dispatch('SetLoading', false)
                        throw new Error(msg);
                      }

                      let flag = false;
                      const h = this.$createElement;
                      let content = [];
                      this.form.details.forEach((detail, index) => {
                        res.returnData.data.forEach((item) => {
                          if (
                            // item.billingLogo == 1 &&
                            detail.supplierProductId == item.id &&
                            detail.price != item.purchasePrice
                          ) {
                            content.push(
                              h(
                                "p",
                                `第【${index + 1}】行产品的采购价【${detail.price
                                }】与供应商产品目录里的采购价【${item.purchasePrice
                                }】不一致;`
                              )
                            );
                            flag = true;
                          }
                        });
                      });
                      if (flag) {
                        content.push(
                          h(
                            "p",
                            {
                              style: "color:red",
                            },
                            `是否继续验收？`
                          )
                        );

                        this.$confirm("提示", {
                          title: "提示",
                          type: "warning",
                          message: h("div", content),
                        }).then(() => {
                          // 上传订单
                          this.save();
                        });
                      } else {
                        this.save();
                      }
                    });
                }
              }
            });
          } else {
            ValidateSupplierProducts({
              ids: supplierProductIds,
            })
              .then((res) => {
                if (res.returnData && res.returnData.length > 0) {
                  const h = this.$createElement;
                  let msg = "";
                  let content = [];
                  res.returnData.forEach((item) => {
                    for (let i = 0; i < this.form.details.length; i++) {
                      if (this.form.details[i].supplierProductId == item.key) {
                        content.push(
                          h(
                            "p",
                            `第${i + 1}行：产品名称[${this.form.details[i].productName
                            }]，规格型号[${this.form.details[i].specName}]${item.errorMessage
                            }\n`
                          )
                        );
                        msg += `第${i + 1}行：产品名称[${this.form.details[i].productName
                          }]，规格型号[${this.form.details[i].specName}]${item.errorMessage
                          },\n`;
                      }
                    }
                  });
                  content.push(h("p", `审核通过才能验收。`));
                  msg += "审核通过才能验收。";

                  // this.$alert(msg)
                  this.$confirm("提示", {
                    title: "提示",
                    type: "warning",
                    customClass: "promptBox",
                    showCancelButton: false,
                    showConfirmButton: true,
                    message: h("div", content),
                  });
                  throw new Error(msg);
                }
              })
              .then(() => {
                return GetSupplierProducts({
                  ids: supplierProductIds,
                  pageIndex: 1,
                  pageSize: 999,
                });
              })
              // GetSupplierProducts({ ids: supplierProductIds, pageIndex: 1, pageSize: 999 })
              .then((res) => {
                let msg = "";
                res.returnData.data.forEach((item) => {
                  if (item.isEnabled == 0 && item.isTempPurchase == 0) {
                    this.form.details.forEach((detail, index) => {
                      if (detail.supplierProductId == item.id) {
                        msg += `第${index + 1}行：${detail.no} 产品名称 [${detail.productName
                          }] 规格型号 [${detail.specName}] <br/>`;
                      }
                    });
                  }
                });
                if (msg) {
                  msg += "已被禁用，请核对后再验收";
                  this.$my_message(msg, "warning");
                  this.$store.dispatch('SetLoading', false)
                  throw new Error(msg);
                }

                let flag = false;
                const h = this.$createElement;
                let content = [];
                this.form.details.forEach((detail, index) => {
                  res.returnData.data.forEach((item) => {
                    if (
                      // item.billingLogo == 1 &&
                      detail.supplierProductId == item.id &&
                      detail.price != item.billingPrice
                    ) {
                      content.push(
                        h(
                          "p",
                          `第【${index + 1}】行产品的采购价【${detail.price
                          }】与供应商产品目录里的采购价【${item.billingPrice}】不一致;`
                        )
                      );
                      flag = true;
                    }
                  });
                });
                if (flag) {
                  content.push(
                    h(
                      "p",
                      {
                        style: "color:red",
                      },
                      `是否继续验收？`
                    )
                  );

                  this.$confirm("提示", {
                    title: "提示",
                    type: "warning",
                    message: h("div", content),
                  }).then(() => {
                    // 上传订单
                    this.save();
                  });
                } else {
                  this.save();
                }
              });
          }
        };
        if (!this.system_setting.IsFirWarehouseStockMode) {

          // 近效期校验
          var productPeriodValidate = this.checkPeriodDayValidate(this.form.details);
          if (!productPeriodValidate.flag) {
            const h = this.$createElement;
            let content = [];
            content.push(
              h(
                "p",
                `${productPeriodValidate.msg}`,
                {
                  style: "color:red",
                },
                `是否继续验收？`
              )
            );
            this.$confirm("提示", {
              title: "提示",
              type: "warning",
              customClass: "promptBox",
              showCancelButton: true,
              showConfirmButton: true,
              message: h("div", content),
            }).then(() => {
              fn();
            });
            // throw new Error(productPeriodValidate.msg);
          } else {
            fn();
          }
        } else {
          fn();
        }

      });


    },
    save() {
      this.SaveDataAction(this.form).then((res) => {
        this.$my_message(`执行成功`, "success");
        sessionStorage.setItem("editMode", 0);
        this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
      }).finally(() => {
        this.$store.dispatch('SetLoading', false)
      });;
    },
    // 上传附件
    filesChange(fileList) {
      this.form.fileInfos = fileList;
    },
    resetForm() {
      this.form = {
        supplierId: "",
        deliveryTime: new Date(),
        warehouseCategory: "1",
        warehouseId: "",
        totalNumber: 0,
        totalAmount: 0,
        orderNo: "",
        category: 0,
        remark: "",
        details: [],
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        warehouseId: "",
        warehouseName: "",
        warehouseManagerId: "",
        warehouseManagerName: "",
        oneLevelWarehouseId: '',
        deptId: "",
        orgCode: sessionStorage.getItem('orgId'),

      };

      this.setDefaultOneLevelWarehouseBySessionWarehouseId()

      this.getWarehouseList("").then((res) => {
        this.getProductList("", 1);

        let deptId = this.userInfo.deptId;
        let warehouseId = this.userInfo.defaultWarehouseId;

        let arr = this.warehouseList.filter(
          (item) => item.id == warehouseId && item.deptIds == deptId + ""
        );
        console.log(warehouseId, deptId, arr);
        if (arr && arr.length > 0) {
          // this.form.warehouseId = warehouseId;
          // this.form.warehouseName = arr[0].name + " " + arr[0].deptNames;
          this.form.warehouseManagerId = arr[0].managerId;
          this.form.warehouseManagerName = arr[0].managerName;
          this.form.deptId = arr[0].deptIds;
        }
      });
    },
    // 取消编辑
    cancel() {
      this.$store.dispatch('SetLoading', false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm() {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.getProductList('')
      this.isScan = false;
    },
    handleDeleteChildForm() {
      if (this.checkIsRfid(this.childMultipleSelection)) {
        this.$my_message(`存在打包类标签明细，不能删除！`, "warning");
        return
      }

      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });
      if (this.$refs.customTable) {
        this.$refs.customTable.callChildMethod().clearSelection()
      }
      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.autoTotalAmount();
    },
    handleChildSelectionChange(selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick(row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
      this.isScan = false;
      this.getProductRegistCertDetails(this.childForm.productId);
    },

    resetDetailFormData() {
      this.childForm = {
        $index: this.form.details.length + 1,
        no: "",
        productName: "",
        specName: "",
        manufacturerName: "",
        locationName: "",
        mainNo: "",
        traceNo: "",
        productId: "",
        specId: "",
        productRegistCertId: "",
        productRegistCertNo: "",
        onlineNo: "",
        unit: "",
        minUnit: "",
        packSpec: "",
        manufacturerId: "",
        locationId: "",
        manufactureDate: "",
        batch: "",
        validityDate: "",
        serialNo: "",
        number: 0,
        unUseNumber: 0,
        refundNumber: 0,
        price: 0,
        amount: 0,
        remark: "",
        packNumber: 0,
      };
    },
    cancelChildDialog() {
      this.updateShowWarning()
      this.openSubformModal = false;
    },
    submitChildForm() {
      this.updateShowWarning()
      this.pushChildForm(true);
      this.$nextTick(() => {
        // 查找弹出框的按钮行
        const dialogFooter = document.querySelector(".el-message-box__btns");
        if (dialogFooter) {
          // 检查是否已经存在 .custom-span
          const existingSpan = dialogFooter.querySelector(".custom-span");
          if (existingSpan) {
            // 如果已存在，则移除整个 span 元素，包括复选框
            dialogFooter.removeChild(existingSpan);
          }
        }
      });
    },
    continueAdd() {
      this.editChildren = false;
      this.pushChildForm();
      // this.resetDetailFormData();

      this.getProductList("");
    },
    childNumberChange() {
      this.childForm.unUseNumber = this.childForm.number;
      this.autoAmount();
    },
    autoAmount() {
      this.childForm.billingPrice = this.childForm.price;
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(4) * 1;
      // this.childForm.unBillAmount = this.childForm.amount;
    },
    autoTotalAmount() {

      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      console.log(this.form.totalAmount);

      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
      this.form.unBillNumber = totalNumber;
      this.form.unBillAmount = totalAmount;
    },

    // scan

    openScanner(ev) {
      this.count = 0;
      this.resetDetailFormData();
      this.isScan = true;
      this.openSubformModal = true;

      ev.target.blur();
    },

    // change event
    childLocationChange(val) {
      this.childForm.locationId = val;
    },
    supplierChange(val) {
      this.form.supplierId = val;
      this.form.supplierName = this.STATIC_Suppliers.filter(
        (item) => item.id == val
      )[0].name;
      this.getProductList("", 1);
      // this.getOrderList("");
      // this.form.orderNo = "";
      // this.form.orderId = "";
    },
    stockUpPleasesChange(val) {
      this.form.stockUpPleaseId = val;
      let arr = this.STATIC_GetStockUpPleases.filter(
        (item) => item.id == val
      )[0]

      this.form.stockUpPleaseNo = arr.no + ' ' + arr.applyDeptName
      this.form.oneLevelWarehouseName = arr.warehouseName;
      this.form.oneLevelWarehouseId = arr.warehouseId;
      this.form.warehouseManagerName = arr.warehouseManagerName
      this.form.warehouseManagerId = arr.warehouseManagerId


      let query = {
        userId: this.userInfo.id,
        category: 1,
        warehouseId: this.form.oneLevelWarehouseId,
        stockUpPleaseId: this.form.stockUpPleaseId,
        loginDeptId: this.mySessionStorage.getDeptId(),
        loginWarehouseId: this.mySessionStorage.getWarehouseId()
      }
      GetStockViewModelsByPleaseId(query).then(res => {
        if (res && res.returnData) {
          this.form.details = res.returnData.map(val => {
            val.number = val.stockQuantity
            val.unUseNumber = val.number
            return val
          })
          this.autoTotalAmount()
        }
      })


      if (this.system_setting.IsUseWard) {
        GetWarehousesByDeptIdAndWard({ deptIdAndWardIdGroup: `${this.form.applyDeptId}${this.form.wardId ? '-' + this.form.wardId : ''}` }).then(res => {
          this.form.warehouseName = res.returnData.name;
          this.form.warehouseId = res.returnData.id;
        }).then(() => {
          // fn()
        })
      } else {
        GetWarehousesByDeptId({
          deptId: this.form.applyDeptId
        })
          .then((res) => {
            this.form.warehouseName = res.returnData.name;
            this.form.warehouseId = res.returnData.id;
          })

      }



      this.getProductList("", 1);

    },
    certChange(val) {
      var cert = this.STATIC_ProductRegistCertDetails.find(
        (item) => item.productRegistCertId === val
      );
      if (cert) {
        this.childForm.productRegistCertId = val;
        this.childForm.productRegistCertNo = cert.no;
        this.childForm.productRegistCertName = cert.name;
        this.childForm.manufacturerId = cert.manufacturerId;
        this.childForm.manufacturerName = cert.manufacturerName;
      }
    },
    warehouseChange(val) {
      // let arr = this.STATIC_Warehouses.filter(item => item.id == val)
      // this.form.warehouseId = val
      // this.form.warehouseName = arr[0].name
      // this.form.warehouseManagerId = arr[0].managerId
      // this.form.warehouseManagerName = arr[0].managerName
      // this.getLocations(this.form.warehouseId);

      var ids = val.split(";");
      if (ids && ids.length > 0) {
        this.form.warehouseId = ids[0];
        let arr = this.warehouseList.filter(
          (item) => item.id == ids[0] && item.deptIds == ids[1]
        );
        this.form.warehouseName = arr[0].name + " " + arr[0].deptNames;
        this.form.warehouseManagerId = arr[0].managerId;
        this.form.warehouseManagerName = arr[0].managerName;
        this.form.deptId = arr[0].deptIds;
      } else {
        this.form.warehouseId = "";
        this.form.warehouseName = "";
        this.form.warehouseManagerId = "";
        this.form.warehouseManagerName = "";
        this.form.deptId = "";
      }
      this.getLocations(this.form.warehouseId);
    },
    applyDeptChange1(val) {
      let arr = this.STATIC_Depts.filter(res => res.idGroup == val)
      this.form.warehouseName = arr[0].warehouseName + '' + arr[0].deptName + " " + (arr[0].wardName ? arr[0].wardName : '');
      this.form.deptId = arr[0].deptId
      this.form.wardId = arr[0].wardId
      this.form.warehouseId = arr[0].warehouseId

      GetWarehouseById({ id: this.form.warehouseId }).then(res => {

        this.form.warehouseManagerId = res.returnData.managerId;
        this.form.warehouseManagerName = res.returnData.managerName;
      });
    },
    productChange(row) {
      console.log(row);

      let id = this.childForm.id;
      // let arr = this.STATIC_ApplySupplierProducts.filter((item) => item.id == row.id)
      this.childForm = Object.assign(this.childForm, row);
      if (!this.system_setting.IsFirWarehouseStockMode) {
        this.childForm.supplierProductNo = row.no;
        this.childForm.supplierProductId = row.id
      }
      this.childForm.id = id;
      this.childForm.number = 1;
      this.childForm.unUseNumber = 1;
      if (this.system_setting.IsFirWarehouseStockMode) {
        this.childForm.price = row.price ? row.price : ''
      } else {
        this.childForm.price = this.childForm.purchasePrice;


      }
      this.childForm.amount = this.childForm.price;
      this.childForm.packNumber = 0;
      this.childForm.remark = "";
      this.$refs.number.focus();
      this.$refs.number.select();

      // this.$refs.childForm.validateField('productName')

      this.getProductRegistCertDetails(this.childForm.productId);
    },

    oneLevelWarehouseChange1(val) {
      console.log(val);

      this.form.oneLevelWarehouseId = val;
      let arr = this.STATIC_OneLevelWarehouses.filter((item) => item.id == val);
      this.form.oneLevelWarehouseManagerId = arr ? arr[0].managerId : "";
      this.getProductList()
      this.$forceUpdate()
    },
    oneLevelWarehouseChange(val) {
      console.log(val);
      this.form.oneLevelWarehouseId = val;
      let arr = this.STATIC_Warehouses.filter((item) => item.id == val);
      this.form.oneLevelWarehouseManagerId = arr ? arr[0].managerId : "";
      this.getProductList()
      this.$forceUpdate()
    },

    getProductList(keyWord, num) {
      let IsEnabledTempPurchaseGroup = num == 1 ? num : "";
      let query = {}
      if (this.system_setting.IsFirWarehouseStockMode) {
        query.keyWord = keyWord
        query.pageIndex = 1
        query.pageSize = 50
        query.stockUpPleaseId = this.form.stockUpPleaseId
        query.category = 1
        query.loginWarehouseId = this.form.oneLevelWarehouseId
        query.warehouseId = this.form.oneLevelWarehouseId

        GetStocks(query).then(res => {
          this.STATIC_SupplierProducts = res.returnData.data
        })
      } else {
        query.keyWord = keyWord,
          query.pageIndex = 1,
          query.pageSize = 100,
          query.supplierId = this.form.supplierId,
          query.isEnabled = 1,
          query.status = 2,
          query.IsEnabledTempPurchaseGroup = 1,
          this.getSupplierProducts(query)
      }
    },
    getWarehouseList(keyWord) {
      // GetDeptWarehouses({ keyWord: keyWord, state: 1 })
      //   .then(res => {
      //     this.warehouseList = res.returnData;
      //   })



      return new Promise((resolve, reject) => {
        GetDeptWarehouses({
          keyWord: keyWord,
          hasOneLevelWarehouse: false,
          state: 1,
        }).then((response) => {
          if (response && response.returnData) {
            this.warehouseList = response.returnData;
            resolve(response.returnData);
          } else {
            reject(response);
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
<style>
.promptBox {
  width: 800px !important;
  max-height: 300px;
}

.el-table .success-row {
  background: #51e09b;
}
</style>